import { Box } from '@ksyos/design-system';
import { useViewportWidth } from '@frontend/utils';
import { OutclinicDashboardTableSwitchBox } from './OutclinicDashboardTableSwitchBox';

export interface ISwitch {
    isChecked: boolean;
    key: 'warningsOnly' | 'hideSnoozed';
    label: string;
    onChange: () => void;
}

interface IOutclinicDashboardTableSwitchesProps {
    switches: ISwitch[];
}

export function OutclinicDashboardTableSwitches(props: IOutclinicDashboardTableSwitchesProps) {
    const { width } = useViewportWidth();

    return (
        <Box
            display="flex"
            flexDirection="row"
            gap={[4, null, 8]}
            justifyContent={[null, null, 'flex-end']}
            marginBottom={[4, null, 10]}
        >
            {props.switches.map((item) => (
                <OutclinicDashboardTableSwitchBox
                    isChecked={item.isChecked}
                    key={item.key}
                    label={item.label}
                    onChange={item.onChange}
                    size={width < 1024 ? 'medium' : 'large'}
                    switchKey={item.key}
                />
            ))}
        </Box>
    );
}
